<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <!-- <el-button size="mini" type="primary" @click="create" icon="el-icon-plus" v-if="$permission.canWrite()">添加</el-button> -->
        <!-- <el-button size="mini" class="filter-item" type="danger" @click="delRows" v-if="$permission.canDel()">删除</el-button> -->
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
              <el-button type="text" icon="el-icon-edit" @click="details(row)"></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <detail-dialog ref="detailDialog" @close-saved="reload"></detail-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sale/return/list";
import detailDialog from "@/components/sale/return/detailDialog";

export default {
  name: "return",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
  },
  methods: {
    details(row) {
      // this.$refs.detailDialog.openDetailsById(row.RecoredId);
      this.$refs.detailDialog.openDetails(row);
    },
    // delRows() {
    //   let rows = this.$refs.list.getCheckedRows();
    //   if (rows.length == 0) {
    //     this.$message.warning("请选择要删除的数据");
    //     return;
    //   }
    //   this.$confirm("确认删除所选的数据吗？", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       let ids = rows.map((item) => {
    //         return item.FreightId;
    //       });
    //       this.$refs.list.delRange(ids);
    //     })
    //     .catch(() => {});
    // },
  },
};
</script>